import { useMutation, useQueryClient } from '@tanstack/react-query';
import { teamsService } from '../services/teamsService';

export const useAddUserToTeam = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      teamId,
      userId,
      role,
    }: {
      teamId: string;
      userId: string;
      role?: string;
    }) => teamsService.addUserToTeam({ teamId, userId, role }),

    onSuccess: (_, variables) => {
      // Invalidate team members list
      queryClient.invalidateQueries({ queryKey: ['team-members', variables.teamId] });
      // Invalidate team details (may have updated member count)
      queryClient.invalidateQueries({ queryKey: ['teams', variables.teamId] });
    }
  });
};
